import { createContext, useState } from "react";

import {
  getEmailAccounts,
  disconnectEmailAccount,
} from "../services/email.service";

export const EmailContext = createContext();
export const EmailProvider = ({ children }) => {
  const [accounts, setAccounts] = useState([]);

  let emailContext = {
    emailAccounts: accounts,

    getEmails: async () => {
      let resp = await getEmailAccounts();

      console.log(resp.data);
      if (!!resp.data.error) {
        console.log("Error getting accounts", resp.data.error);
        setAccounts([]);
      }

      setAccounts(resp.data?.accounts || []);
    },

    disconnectEmail: async (account_id) => {
      let resp = await disconnectEmailAccount(account_id);
      if (!!resp.error) {
        console.log("Error disconnecting account:", resp.error);
        return;
      }

      setAccounts(resp.data?.accounts || []);
    },
  };

  return (
    <EmailContext.Provider value={emailContext}>
      {children}
    </EmailContext.Provider>
  );
};
